<template>
  <div id="root">
    <h1>Depth Chart</h1>
    <el-button v-if="!personId" type="primary" @click.native="modals.addDepthChart = true">
      Add <i class="el-icon-plus el-icon--right" />
    </el-button>
    <el-button v-if="!personId" type="danger" @click.native="modals.removeDepthChart = true">
      Remove <i class="el-icon-minus el-icon--right" />
    </el-button>
    <div class="container-fluid">
      <div class="row">
        <!-- <p>{{ depthChart }}</p> -->
        <div class="col-md">
          <p style="text-align:center" class="dc-headings">
            New Contacts
          </p>
          <draggable
            v-if="!personId"
            class="list-group"
            tag="ul"
            :list="newContactsList"
            v-bind="dragOptions"
            :move="onMove"
            @start="isDragging=true"
            @end="isDragging=false"
            id="new-contacts"
          >
            <transition-group type="transition" :name="'flip-list'">
              <li class="list-group-item" v-for="element in newContactsList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </draggable>
          <div v-if="personId">
            <transition-group type="transition" :name="'flip-list'">
              <li class="list-group-item no-drag" v-for="element in newContactsList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </div>
        </div>

        <div class="col-md">
          <p style="text-align:center" class="dc-headings">
            Meaningful Contacts
          </p>
          <draggable
            v-if="!personId"
            element="span"
            v-model="meaningfulContactsList"
            v-bind="dragOptions"
            :move="onMove"
            id="meaningful-contacts"
          >
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item" v-for="element in meaningfulContactsList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </draggable>
          <div v-if="personId">
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item no-drag" v-for="element in meaningfulContactsList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </div>
        </div>
        <div class="col-md">
          <p style="text-align:center" class="dc-headings">
            Bible Study Participants
          </p>
          <draggable
            v-if="!personId"
            element="span"
            v-model="bibleStudyParticipantsList"
            v-bind="dragOptions"
            :move="onMove"
            id="bible-study-participants"
          >
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item" v-for="element in bibleStudyParticipantsList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </draggable>
          <div v-if="personId">
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item no-drag" v-for="element in bibleStudyParticipantsList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </div>
        </div>
        <div class="col-md">
          <p style="text-align:center" class="dc-headings">
            Growing Disciples
          </p>
          <draggable
            v-if="!personId"
            element="span"
            v-model="growingDisciplesList"
            v-bind="dragOptions"
            :move="onMove"
            id="growing-disciples"
          >
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item" v-for="element in growingDisciplesList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </draggable>
          <div v-if="personId">
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item no-drag" v-for="element in growingDisciplesList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </div>
        </div>
        <div class="col-md">
          <p style="text-align:center" class="dc-headings">
            Commissioned Disciples
          </p>
          <draggable
            v-if="!personId"
            element="span"
            v-model="commissionedDisciplesList"
            v-bind="dragOptions"
            :move="onMove"
            id="commissioned-disciples"
          >
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item" v-for="element in commissionedDisciplesList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </draggable>
          <div v-if="personId">
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item no-drag" v-for="element in commissionedDisciplesList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </div>
        </div>
        <div class="col-md">
          <p style="text-align:center" class="dc-headings">
            Bible Study Leaders
          </p>
          <draggable
            v-if="!personId"
            element="span"
            v-model="bibleStudyLeadersList"
            v-bind="dragOptions"
            :move="onMove"
            id="bible-study-leaders"
          >
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item" v-for="element in bibleStudyLeadersList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </draggable>
          <div v-if="personId">
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item no-drag" v-for="element in bibleStudyLeadersList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </div>
        </div>
        <div class="col-md">
          <p style="text-align:center" class="dc-headings">
            Disciple Makers
          </p>
          <draggable
            v-if="!personId"
            element="span"
            v-model="discipleMakersList"
            v-bind="dragOptions"
            :move="onMove"
            id="disciple-makers"
          >
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item" v-for="element in discipleMakersList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </draggable>
          <div v-if="personId">
            <transition-group name="no" class="list-group" tag="ul">
              <li class="list-group-item no-drag" v-for="element in discipleMakersList" :key="element.id">
                {{ element.name }}
              </li>
            </transition-group>
          </div>
        </div>
        <div id="loading" v-if="(isReady == false) && (!error)">
          <h5>
            Loading...
          </h5>
        </div>
        <!-- <div class="list-group col-md-3">
        <pre>{{ listString }}</pre>
      </div>
      <div class="list-group col-md-3">
        <pre>{{ list2String }}</pre>
      </div> -->
        <add-depth-chart-modal
          :show="modals.addDepthChart"
          :person-id="personId"
          @close="modals.addDepthChart = false"
          @save="getDepthChart"
        />
        <remove-depth-chart-modal
          :show="modals.removeDepthChart"
          :person-id="personId"
          @close="modals.removeDepthChart = false"
          @save="getDepthChart"
        />
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable';
import { mapState } from 'vuex';
import AddDepthChartModal from './AddDepthChartModal';
import RemoveDepthChartModal from './RemoveDepthChartModal';
import { RepositoryFactory } from '../../repositories/repositoryFactory';

const DepthChartsRepository = RepositoryFactory.get('depthCharts');

const data = 'Depth Chart';

export default {
    components: {
        draggable,
        AddDepthChartModal,
        RemoveDepthChartModal
    },
    props: {
        personId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            title: 'Depth Chart',
            namespace: 'DepthChart',
            newContactsList: [],
            meaningfulContactsList: [],
            bibleStudyParticipantsList: [],
            growingDisciplesList: [],
            commissionedDisciplesList: [],
            bibleStudyLeadersList: [],
            discipleMakersList: [],
            editable: true,
            isReady: false,
            transferring: false,
            isDragging: false,
            delayedDragging: false,
            modals: {
                addDepthChart: false,
                removeDepthChart: false
            },
        };
    },
    watch: {
        personId() {
            this.getDepthChart();
        },
        isDragging(newValue) {
            if (newValue) {
                this.delayedDragging = true;
                return;
            }
            this.$nextTick(() => {
                this.delayedDragging = false;
            });
        }
    },
    computed: {
        ...mapState({
            depthChart: (state) => state.DepthChart.depthChart,
            error: (state) => state.DepthChart.error,
        }),
        dragOptions() {
            return {
                animation: 0,
                group: 'description',
                disabled: !this.editable,
                ghostClass: 'ghost'
            };
        },
        listString() {
            return JSON.stringify(this.list, null, 2);
        },
        list2String() {
            return JSON.stringify(this.list2, null, 2);
        }
    },
    methods: {
        // i dont know what this is, but russell had it
        getIdFromIndex(index) {
            return this.depthCharts[index].id;
        },
        getDepthChart() {
            this.$store.dispatch(`${this.namespace}/getDepthChartByPerson`,
                { personId: this.personId }).then((response) => {
                this.newContactsList = this.depthChart['New Contacts']
                    .map((chart) => ({ name: chart.chart_member, id: chart.chart_member_id }));
                this.meaningfulContactsList = this.depthChart['Meaningful Contacts']
                    .map((chart) => ({ name: chart.chart_member, id: chart.chart_member_id }));
                this.bibleStudyParticipantsList = this.depthChart['Bible Study Participants']
                    .map((chart) => ({ name: chart.chart_member, id: chart.chart_member_id }));
                this.growingDisciplesList = this.depthChart['Beginning/Growing Disciples']
                    .map((chart) => ({ name: chart.chart_member, id: chart.chart_member_id }));
                this.commissionedDisciplesList = this.depthChart['Commissioned Disciples']
                    .map((chart) => ({ name: chart.chart_member, id: chart.chart_member_id }));
                this.bibleStudyLeadersList = this.depthChart['Bible Study Leaders']
                    .map((chart) => ({ name: chart.chart_member, id: chart.chart_member_id }));
                this.discipleMakersList = this.depthChart['Disciple Makers']
                    .map((chart) => ({ name: chart.chart_member, id: chart.chart_member_id }));
                this.isReady = true;
            });
        },
        onMove({ relatedContext, draggedContext }) {
            if (this.transferring === false) {
                this.transferring = true;
                // console.log(draggedContext.element.id); //for testing
                // console.log(relatedContext.component.$attrs.id);

                DepthChartsRepository.transferDepthChart(
                    draggedContext.element.id,
                    relatedContext.component.$attrs.id
                )
                    .then((response) => {
                    // console.log('yay');
                        this.saving = false;
                        this.$emit('depthChartChange');
                        this.$message(response.data.message);
                        this.transferring = false;
                        const relatedElement = relatedContext.element;
                        const draggedElement = draggedContext.element;
                        return (
                            (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
                        );
                    })
                    .catch((error) => {
                        this.getDepthChart();
                        this.saving = false;
                        this.transferring = false;
                        this.$message(error.response.data.message);
                    });
            } else {
                return false;
            }
        }

    },
    created() {
        this.getDepthChart();
    }
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
.dc-headings {
    position: relative;
    display: block;
    padding: .75rem 1.25rem;
    margin-bottom: -1px;
    background-color: #77ab59;
    color: white;
    border: 1px solid rgba(0,0,0,.125);
}
#loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 15%;
  padding: 20px;
}
</style>
<style scoped>
.no-drag {
  cursor: auto !important;
}
</style>
